exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.view-type .el-dropdown{\n  padding: 0 8px;\n}\n.oper-drop .el-dropdown-menu__item{\n  width: 45px;\n}\n.oper-drop .el-dropdown-menu__item.active{\n  background-color: #e6f8f3;\n  color: #00BD89;\n}\n", ""]);

// exports
